var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWater = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M17.096 21.688c-1.533 0-3.064-1.532-4.596-1.532s-3.063 1.532-4.596 1.532c-1.532 0-3.063-1.532-4.595-1.532-.995 0-2.068.689-3.063 1.148v3.064c.995-.46 2.068-1.15 3.063-1.15 1.532 0 3.063 1.533 4.595 1.533 1.533 0 3.064-1.532 4.596-1.532s3.063 1.532 4.596 1.532c1.532 0 3.063-1.532 4.595-1.532.995 0 2.068.69 3.063 1.149v-3.064c-.995-.46-2.068-1.148-3.063-1.148-1.532 0-3.063 1.532-4.595 1.532zm4.595-7.658c-1.532 0-3.063 1.532-4.595 1.532-1.533 0-3.064-1.532-4.596-1.532s-3.063 1.532-4.596 1.532c-1.532 0-3.063-1.532-4.595-1.532-.995 0-2.068.69-3.063 1.149v3.063c.995-.46 2.068-1.149 3.063-1.149 1.532 0 3.063 1.533 4.595 1.533 1.533 0 3.064-1.533 4.596-1.533s3.063 1.533 4.596 1.533c1.532 0 3.063-1.533 4.595-1.533.995 0 2.068.69 3.063 1.15v-3.064c-.995-.46-2.068-1.149-3.063-1.149zM16.33 8.67c0-2.144-3.83-8.426-3.83-8.426S8.67 6.524 8.67 8.67c0 2.144 1.684 3.83 3.83 3.83 2.144 0 3.83-1.685 3.83-3.83z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWater, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/water.87ed5f70.svg";
export { ForwardRef as ReactComponent };